/**
 *  StartingLights
 *
 *  Created by Legman on 08/06/2017.
 *
 */

import Common from "./Common";

export default class StartingLights extends PIXI.Container {
    constructor() {
        super();

        /**
         * @type {Array.<PIXI.Sprite>}
         * @private
         */
        this._lights = [];

        /**
         * @type {Array.<TweenMax>}
         * @private
         */
        this._tweens = [];

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("wr_race_lights_bg"));
        bg.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(bg);

        const positions = [
            new PIXI.Point(-88, 48),
            new PIXI.Point(-35, 48),
            new PIXI.Point(35, 48),
            new PIXI.Point(84, 48)
        ];

        for (let i = 0; i < positions.length; ++ i) {
            const light = new PIXI.Sprite(assets.getTexture("wr_race_lights_red"));
            light.position = positions[i].clone();
            light.scale.x = i < 2 ? 1 : -1;
            light.anchor = new PIXI.Point(0.5, 0.5);
            light.visible = false;
            this.addChild(light);
            this._lights.push(light);
        }
        for (let i = 0; i < positions.length; ++ i) {
            const light = new PIXI.Sprite(assets.getTexture("wr_race_lights_green"));
            light.position = positions[i].clone();
            light.scale.x = i < 2 ? 1 : -1;
            light.anchor = new PIXI.Point(0.5, 0.5);
            light.visible = false;
            this.addChild(light);
            this._lights.push(light);
        }
    }

    destroy() {
        for (let i = 0; i < this._tweens.length; ++ i) {
            const tween = this._tweens[i];
            tween.kill();
        }
        this._tweens.length = 0;

        super.destroy({removeChildren: true});
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        const to = this.y;
        this.y -= 200;
        this._tweens.push(TweenMax.to(this, 0.4, {
            y: to,
            ease: Back.easeOut,
            easeParams: [1],
            onComplete: callback,
            onCompleteScope: scope
        }));
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
        const to = this.y - 200;
        this._tweens.push(TweenMax.to(this, 0.4, {
            delay: 0.4,
            y: to,
            ease: Back.easeIn,
            onComplete: callback,
            onCompleteScope: scope
        }));
    }

    /**
     * @param {number} [time]
     * @param {function} [callback]
     * @param {*} [scope]
     */
    start(time, callback, scope) {
        let index = 0;

        red.call(this);
        function red() {
            const light = this._lights[index];
            light.alpha = 0;
            light.visible = true;

            this._tweens.push(TweenMax.to(light, 0.04, {
                delay: time,
                alpha: 1,
                ease: Power2.easeInOut,
                onComplete: function() {
                    if (++ index < 4) {
                        red.call(this);
                        Common.audio.playSound("sfx_race_lights_count_00");
                    } else {
                        delay(green, 1, this);
                        Common.audio.playSound("sfx_race_lights_count_00");
                    }
                },
                onCompleteScope: this
            }));
        }

        function green() {
            for (let i = 0; i < 4; ++ i) {
                const light = this._lights[i];
                light.visible = false;
            }
            for (let i = 4; i < this._lights.length; ++ i) {
                const light = this._lights[i];
                light.visible = true;

                light.alpha = 0;
                this._tweens.push(TweenMax.to(light, 0.04, {
                    alpha: 1,
                    ease: Power2.easeInOut
                }));
            }
            callback && callback.call(scope);

            Common.audio.playSound("sfx_race_lights_go_00");
        }
    }

    resume() {
        for (let i = 0; i < this._tweens.length; ++ i) {
            const tween = this._tweens[i];
            tween.resume();
        }
    }

    pause() {
        for (let i = 0; i < this._tweens.length; ++ i) {
            const tween = this._tweens[i];
            tween.pause();
        }
    }
}